import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Login from './pages/login/Login.jsx';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {AuthProvider} from './context/AuthProvider';
import RequireAuth from './pages/login/RequireAuth';
import Main from './pages/mainPage/Main';
import BilletView from './pages/billet/BilletView';
import Page404 from './pages/Page404';
import Page403 from './pages/Page403';
import Page401 from './pages/Page401';
import TableBillet from './pages/billet/TableBillet';
import Forgot from './pages/password/Forgot';
import UserTable from './pages/user/UserTable';
import UserForm from './pages/user/UserForm';
import Reset from './pages/password/Reset';
import LoginForm from './pages/login/LoginForm';

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route element={<RequireAuth/>}>
                        <Route path="/" element={<Main/>}>
                            <Route path="billets">
                                <Route path="" element={<TableBillet/>}/>
                                <Route path="view" element={<BilletView/>}/>
                            </Route>
                            <Route path="users">
                                <Route path="" element={<UserTable/>}/>
                                <Route path="new" element={<UserForm/>}/>
                                <Route path=":userId/view" element={<UserForm/>}/>
                                <Route path=":userId/edit" element={<UserForm/>}/>
                            </Route>
                        </Route>
                    </Route>
                    <Route path="" element={<Login/>}>
                        <Route path="/login" element={<LoginForm/>}/>
                        <Route path="/register" element={<Forgot/>}/>
                        <Route path="/password">
                            <Route path="forgot" element={<Forgot/>}/>
                            <Route path="reset" element={<Reset/>}/>
                        </Route>
                    </Route>
                    <Route path="/page401" element={<Page401/>}/>
                    <Route path="/page403" element={<Page403/>}/>
                    <Route path="*" element={<Page404/>}/>
                </Routes>
            </AuthProvider>
        </BrowserRouter>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);
